<!--Main-->
<template>
  <div class="top-form">
    <div class="filter-container clearfix">
      <div class="left-tools">
        <el-popover placement="bottom-start" trigger="click">
          <div class="cols-setting">
            <ul>
              <li
                v-for="(item, index) in (handle && handle.filterFieldList) ||
                []"
                :key="index"
              >
                <el-checkbox
                  :key="index"
                  v-model="item.value"
                  :label="item.label"
                  class="filter-item"
                  @change="(e) => checkboxOnChange(e, item)"
                  >{{ $t(item.label) }}</el-checkbox
                >
              </li>
            </ul>
          </div>
          <el-button slot="reference" icon="el-icon-s-tools" size="mini" />
        </el-popover>
        <el-button type="primary" size="mini" @click="_toggle">
          <span class="custom-icon">
            <svg-icon icon-class="filter" />
          </span>
        </el-button>
      </div>
      <div class="right-tools">
        <div class="pull-right">
          <template v-for="(item, index) in (handle && handle.btList) || []">
            <el-tooltip
              v-if="item.type === 'button'"
              class="item"
              :key="index"
              :content="item.content"
              :disabled="item.tipDisabled !== false || false"
              placement="bottom-start"
            >
              <el-button
                v-show="item.show"
                :key="index"
                :class="`filter-${item.type}`"
                v-waves
                :plain="item.plain"
                :type="item.btType"
                :icon="item.icon"
                :disabled="item.disabled"
                @click="handleClick(item.event)"
                size="mini"
                style="margin-right: 5px"
                >{{ $t(item.label) }}</el-button
              >
            </el-tooltip>
            <el-tooltip
              v-else-if="item.type === 'button-mini'"
              :key="index"
              class="item"
              :content="item.content"
              :disabled="item.tipDisabled !== false || false"
              placement="bottom-start"
            >
              <el-button-group>
                <slot name="import" />

                <el-button
                  v-waves
                  :type="item.btType"
                  :icon="item.icon"
                  :disabled="item.disabled"
                  @click="handleClick(item.event)"
                  size="mini"
                  >{{ $t(item.label) }}</el-button
                >
              </el-button-group>
            </el-tooltip>
          </template>
        </div>
      </div>
    </div>
    <div v-if="searchForm" class="search-form clearfix">
      <el-form
        ref="pageform"
        :inline="true"
        :model="data"
        :rules="rules"
        size="mini"
        label-width="auto"
      >
        <el-row :gutter="10">
          <template v-for="(item, index) in getConfigList()">
            <el-col
              v-if="item.type == 'input'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :label="$t(item.label)">
                <!-- 输入框 -->
                <el-input
                  v-model="data[item.value]"
                  :type="item.type"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :placeholder="getPlaceholder(item)"
                  @focus="handleEvent(item.event)"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'inputRequire'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :prop="item.value" :label="$t(item.label)" :required="item.required">
                <!-- 输入框 -->
                <el-input
                  v-model="data[item.value]"
                  :type="item.type"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :placeholder="getPlaceholder(item)"
                  @focus="handleEvent(item.event)"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'textarea'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :prop="item.value" :label="$t(item.label)" :required="item.required">
                <!-- 多行输入框 -->
                <el-input
                  v-model="data[item.value]"
                  :type="item.type"
                  :autosize="item.autosize || { minRows: 1, maxRows: 4 }"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :placeholder="getPlaceholder(item)"
                  @focus="handleEvent(item.event)"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'select'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :label="$t(item.label)">
                <!-- 选择框 -->
                <el-select
                  v-model="data[item.value]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :multiple="item.multiple === true ? item.multiple : false"
                  :filterable="item.filterable"
                  :remote="item.remote"
                  :placeholder="getPlaceholder(item)"
                  @focus="handleEvent(item.eventFocus,item)"
                  @change="handleEvent(item.event, data[item.value])"
                >
                  <el-option
                    v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                    :key="childIndex"
                    :label="childItem.key"
                    :value="childItem.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'selectRequired'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :prop="item.value" :label="$t(item.label)" :required="item.required">
                <!-- 选择框 -->
                <el-select
                  v-model="data[item.value]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :multiple="item.multiple === true ? item.multiple : false"
                  :filterable="item.filterable"
                  :placeholder="getPlaceholder(item)"
                  @change="handleEvent(item.event, data[item.value])"
                >
                  <el-option
                    v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                    :key="childIndex"
                    :label="childItem.key"
                    :value="childItem.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'select-brand'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :label="$t(item.label)">
                <!-- 选择框 -->
                <el-select
                  v-model="data[item.value]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :multiple="item.multiple === true ? item.multiple : false"
                  :filterable="item.filterable"
                  :placeholder="getPlaceholder(item)"
                  @change="$forceUpdate()"
                >
                  <el-option
                    v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                    :key="childIndex"
                    :label="childItem.key"
                    :value="childItem.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  v-if="item.switchBrandFlag === true ? true : false"
                  type="danger"
                  size="mini"
                  @click="handleClick(item.switchEvent, data[item.value])"
                  >切换</el-button
                >
              </el-form-item>
            </el-col>

            <el-col
              v-if="item.type == 'datepicker'"
              :key="index"
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12"
              :xl="12"
            >
              <el-form-item :label="$t(item.label)">
                <!-- 开始结束日期 -->
                <el-date-picker
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="item.pickerOptions"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'datetimepicker'"
              :key="index"
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12"
              :xl="12"
            >
              <el-form-item :label="$t(item.label)">
                <!-- 开始结束日期 -->
                <el-date-picker
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="item.pickerOptions"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="item.type == 'date'" :key="index">
              <el-form-item :label="$t(item.label)">
                <el-date-picker
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd"
                  type="date"
                  align="right"
                  :default-value="new Date()"
                  :picker-options="item.pickerOptions"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="item.type == 'datetime'" :key="index">
              <el-form-item :label="$t(item.label)">
                <el-date-picker
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  align="right"
                  :default-value="new Date()"
                  :picker-options="item.pickerOptions"
                />
              </el-form-item>
            </el-col>
            <!-- 二选一单选框 -->
            <el-col
              v-if="item.type == 'radio'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :label="$t(item.label)">
                <el-radio
                  v-model="data[item.value]"
                  :label="item.yes || 'Y'"
                  :placeholder="item.yesLabel || getPlaceholder(item)"
                  >{{ item.yesLabel || $t("table.yes") }}</el-radio
                >
                <el-radio
                  v-model="data[item.value]"
                  :label="item.no || 'N'"
                  :placeholder="item.noLabel || getPlaceholder(item)"
                  >{{ item.noLabel || $t("table.no") }}</el-radio
                >
              </el-form-item>
            </el-col>
            <!-- 二个并列输入框 -->
            <el-col
              v-if="item.type == 'line-input'"
              :key="index"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="6"
              :xl="6"
            >
              <el-form-item :label="$t(item.label)">
                SO-
                <el-input
                  class="line-input"
                  v-model="data[item.value][0]"
                  label=""
                  placeholder=""
                  />
                至
                <el-input
                class="line-input"
                  v-model="data[item.value][1]"
                  label=""
                  placeholder=""
                  />
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <div class="text-center">
          <el-button
            v-for="(item, index) in (handle && handle.formBtList) || []"
            :key="index"
            :class="`filter-${item.type}`"
            v-waves
            :type="item.btType"
            :icon="item.icon"
            :disabled="item.disabled"
            @click="handleClick(item.event)"
            size="mini"
            >{{ $t(item.label) }}</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main",
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    // 表单数据
    data: {
      type: Object,
    },
    tableKey: 0,
    // 相关字段
    fieldList: {
      type: Array,
    },
    // 操作栏配置
    handle: {
      type: Object,
    },
    // 验证规则
    rules: {
      type: Object,
    },
    // 相关的列表
    listTypeInfo: {
      type: Object,
    },
    // label宽度
    labelWidth: {
      type: String,
      default: "120px",
    },
    refObj: {
      type: Object,
    },
    switchBrandFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchForm: this.$route.path.replace("/", "").replace(/_/g, "/") == 'page/toxin/toxinInspectVehicleArragement/index' ? true : false,
      checkeBoxColmuns: [], //被隐藏的列
    };
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.pageform);
      },
      deep: true, // 深度监听
    },
    searchForm() {
      //增加异步触发,searchForm与组件加载完成不同步
      setTimeout(() => {
        this.$emit("update:refObj", this.$refs.pageform);
      }, 0);
    },
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.pageform);
    this.$nextTick(() => {
      this.getColmunList();
    });
  },
  methods: {
    _toggle() {
      this.searchForm = !this.searchForm; // 取反
    },
    _getPageId() {
      let name = this.$route.path.replace("/", "").replace(/_/g, "/");

      let data = JSON.parse(window.sessionStorage.getItem("menus") || "{}");
      let id = null;
      data.forEach((item) => {
        if (item.menuNameNick == name) {
          id = item.id;
        } else {
          item.childMenus.forEach((child) => {
            if (child.menuNameNick == name) {
              id = child.id;
            } else {
              child.childMenus.forEach((menus) => {
                if (menus.menuNameNick == name) {
                  id = menus.id;
                } else {
                  menus.childMenus.forEach((childMenus) => {
                    if (childMenus.menuNameNick == name) {
                      id = childMenus.id;
                    }
                  });
                }
              });
            }
          });
        }
      });
      return id;
    },
    getColmunList() {
      let filterFieldList = this.handle.filterFieldList;
      this.$store
        .dispatch("topForm/listHiddenColumn", { menuId: this._getPageId() })
        .then(() => {
          this.checkeBoxColmuns =
            this.$store.state["topForm"].hiddenColumnObj || [];

          this.handle.filterFieldList = filterFieldList.map((field) => {
            let isHear = this.checkeBoxColmuns.every(
              (colmun) => field.prop != colmun.column
            );

            if (!isHear) this.$emit("handleEvent", field.event, field.prop);

            return {
              ...field,
              value: isHear,
            };
          });
        });
    },
    // 获取字段列表
    getConfigList() {
      if (this.fieldList) {
        return this.fieldList.filter(
          (item) =>
            !item.hasOwnProperty("show") ||
            (item.hasOwnProperty("show") && item.show)
        );
      }
    },
    // 得到placeholder的显示table.inputthis.$t('button.ok')
    getPlaceholder(row) {
      if (row.placeholder) {
        return row.placeholder;
      }
      let placeholder;
      if (row.type === "input" || row.type === "textarea") {
        placeholder = this.$t("table.input") + this.$t(row.label);
      } else if (
        row.type === "select" ||
        row.type === "time" ||
        row.type === "date"
      ) {
        placeholder = this.$t("table.select") + this.$t(row.label);
      } else {
        placeholder = this.$t(row.label);
      }
      return placeholder;
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    remoteMethod(query) {
      this.$emit("remoteMethod", query);
    },
    checkboxOnChange(checked, item) {
      let column = item.prop;
      let columnList = this.handle.filterFieldList
        .filter((item) => !item.value)
        .map((item) => item.prop);

      let data = {
        menuId: this._getPageId(),
        columnList,
      };
      this.$store.dispatch("topForm/userColumnAdd", data).then(() => {
        if (checked)
          this.checkeBoxColmuns = this.checkeBoxColmuns.map((item) =>
            item.column == column ? { ...item, value: true } : item
          );
      });
      this.$emit("handleEvent", item.event, item.prop);
    },
  },
};
</script>
<style scoped>
.el-form--inline .el-form-item {
  margin-right: 0px;
}
</style>





// WEBPACK FOOTER //
// src/components/top-form.vue